import React from 'react'
import { InputEditorFunc, areEditorPropsEqual } from '@/components/report-tables/editors/fInputEditor'
import { isDotNetNullableLongCompatible } from '@/utils/numberUtilities'

const IntEditorFunc = React.memo(function IntEditorFunc (props) {
  return <InputEditorFunc validateValue={isDotNetNullableLongCompatible} {...props} />
}, areEditorPropsEqual)

export { IntEditorFunc }



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/fIntEditor.js